import getEnvironment from './environment';

const LOCALSTORAGE_KEY = 'mpDebug';
const URL_PARAM = 'mpDebug';
const LOG_PREFIX = '[Mixpanel Debug]';

export function isMixpanelDebugEnabled(): boolean {
  if (!getEnvironment().isProd) {
    return true;
  }
  const params = new URLSearchParams(window.location.search);
  return params.has(URL_PARAM) || localStorage.getItem(LOCALSTORAGE_KEY) === '1';
}

export function logMixpanelDebug(eventName: string, properties: Record<string, unknown>): void {
  if (!isMixpanelDebugEnabled()) {
    return;
  }
  // eslint-disable-next-line no-console
  console.info(`${LOG_PREFIX} "${eventName}"`, properties);
}
